export default "__VITE_ASSET__GZmbT7$E__"